import {
  ORDER_STATUS,
  ORDER_STATUS_LABEL,
  ORDERS_PAGE,
  PAYMENT_STATUS,
  type Order,
  type OrderStatus,
  type PaymentStatus,
} from '../constants/orders'

export function isOrderStatus(value: string): value is OrderStatus {
  return (Object.values(ORDER_STATUS) as string[]).includes(value)
}

export function isPaymentStatus(value: string): value is PaymentStatus {
  return (Object.values(PAYMENT_STATUS) as string[]).includes(value)
}

export function orderStatusLabel(status: OrderStatus): string {
  return ORDER_STATUS_LABEL[status]
}

export function deliveryPromiseLabel(isExpress: boolean): string {
  return isExpress ? ORDERS_PAGE.expressSla : ORDERS_PAGE.standardSla
}

export function checkoutRefLabel(checkoutId: string | null | undefined): string | null {
  if (!checkoutId) return null
  return `${ORDERS_PAGE.checkoutLinked} ${checkoutId.slice(0, 8)}`
}

export function formatDeliveryLine(order: Order): string {
  return formatAddressLine(order.delivery)
}

export function formatBillingLine(order: Order): string {
  return formatAddressLine(order.billing)
}

function formatAddressLine(address: {
  address: string
  city: string
  pincode: string | null
}): string {
  return [address.address, address.city, address.pincode]
    .filter((part): part is string => Boolean(part && part.trim()))
    .join(', ')
}

export function withQuery(
  path: string,
  query: Record<string, string | number | undefined | null>,
): string {
  const params = new URLSearchParams()
  for (const [key, value] of Object.entries(query)) {
    if (value === undefined || value === null || value === '') continue
    params.set(key, String(value))
  }
  const qs = params.toString()
  return qs ? `${path}?${qs}` : path
}
